
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue'

import { getCurrentUser } from '@nextcloud/auth'
import { t } from '@nextcloud/l10n'
import moment from '@nextcloud/moment'

import NcButton from '@nextcloud/vue/components/NcButton'
import NcNoteCard from '@nextcloud/vue/components/NcNoteCard'
import NcUserBubble from '@nextcloud/vue/components/NcUserBubble'
import { useIsDarkTheme } from '@nextcloud/vue/composables/useIsDarkTheme'

import AvatarWrapper from '../AvatarWrapper/AvatarWrapper.vue'

import { AVATAR } from '../../constants.ts'

export default {
	name: 'NewMessageAbsenceInfo',

	components: {
		AvatarWrapper,
		ChevronUp,
		NcButton,
		NcNoteCard,
		NcUserBubble,
	},

	props: {
		userAbsence: {
			type: Object,
			required: true,
		},

		displayName: {
			type: String,
			required: true,
		},
	},

	setup() {
		const isDarkTheme = useIsDarkTheme()
		return {
			AVATAR,
			isDarkTheme,
		}
	},

	data() {
		return {
			collapsed: true,
			isTextMoreThanOneLine: false,
			resizeObserver: null,
		}
	},

	computed: {
		token() {
			return this.$store.getters.getToken()
		},

		userAbsenceCaption() {
			return t('spreed', '{user} is out of office and might not respond.', { user: this.displayName }, undefined, {
				escape: false,
				sanitize: false
			})
		},

		userAbsenceMessage() {
			return this.userAbsence.message || this.userAbsence.shortMessage
		},

		userAbsencePeriod() {
			if (!this.userAbsence.startDate || !this.userAbsence.endDate) {
				return ''
			}
			return t('spreed', 'Absence period: {startDate} - {endDate}', {
				startDate: moment(this.userAbsence.startDate * 1000).format('ll'),
				endDate: moment(this.userAbsence.endDate * 1000).format('ll'),
			})
		},
	},

	mounted() {
		this.setIsTextMoreThanOneLine()
		this.resizeObserver = new ResizeObserver(this.setIsTextMoreThanOneLine)
		this.resizeObserver.observe(this.$refs.absenceMessage)
	},

	beforeDestroy() {
		if (this.resizeObserver) {
			this.resizeObserver.disconnect()
		}
	},

	methods: {
		t,
		toggleCollapsed() {
			this.collapsed = !this.collapsed
		},

		setIsTextMoreThanOneLine() {
			if (!this.collapsed) {
				return
			}
			this.isTextMoreThanOneLine = this.$refs.absenceMessage?.scrollHeight > this.$refs.absenceMessage?.clientHeight
		},

		async openConversationWithReplacementUser() {
			if (this.userAbsence.replacementUserId === getCurrentUser().uid) {
				// Don't open a chat with one-self
				return
			}

			if (this.userAbsence.replacementUserId === this.userAbsence.userId) {
				// Don't recursively go to the current chat
				return
			}

			this.$router.push({
				name: 'root',
				query: {
					callUser: this.userAbsence.replacementUserId,
				}
			}).catch(err => console.debug(`Error while pushing the new conversation's route: ${err}`))
		},
	},
}
